import { render, staticRenderFns } from "./CompanyOmsEdit.vue?vue&type=template&id=92b73e94&scoped=true&"
import script from "./CompanyOmsEdit.vue?vue&type=script&lang=js&"
export * from "./CompanyOmsEdit.vue?vue&type=script&lang=js&"
import style0 from "./CompanyOmsEdit.vue?vue&type=style&index=0&id=92b73e94&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "92b73e94",
  null
  
)

export default component.exports